import React, { ReactElement, ReactNode } from 'react';

import { FormattedMessage } from 'react-intl';

const formatGameWin = (winningScore: number, losingScore: number): ReactElement => {
    return (
        <FormattedMessage
            description="Game result for a home team win"
            defaultMessage="W {winningScore}-{losingScore}"
            values={{
                winningScore: winningScore,
                losingScore: losingScore,
            }}
        />
    );
};

const formatGameLoss = (winningScore: number, losingScore: number): ReactElement => {
    return (
        <FormattedMessage
            description="Game result for a home team loss"
            defaultMessage="L {winningScore}-{losingScore}"
            values={{
                winningScore: winningScore,
                losingScore: losingScore,
            }}
        />
    );
};

export const formatGameResult = (
    awayTeamAbbrev: string,
    homeTeamAbbrev: string,
    team: string,
    awayTeamScore: number,
    homeTeamScore: number
): ReactNode => {
    const winningScore = awayTeamScore > homeTeamScore ? awayTeamScore : homeTeamScore;
    const losingScore = awayTeamScore > homeTeamScore ? homeTeamScore : awayTeamScore;
    const homeTeamWin = (awayTeamScore > homeTeamScore ? awayTeamAbbrev : homeTeamAbbrev) === team;
    return homeTeamWin ? formatGameWin(winningScore, losingScore) : formatGameLoss(winningScore, losingScore);
};
